import { useState } from 'react';
import { Github, Home, Layers3, Linkedin, Mail, Menu, MessageSquare, X } from 'lucide-react';
import { usePortfolio } from '../../lib/hooks';
import defaultAvatar from '../../assets/avatar.png';

const navItems = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'projects', label: 'Projects', icon: Layers3 },
  { id: 'stack', label: 'Stack', icon: Layers3 },
  { id: 'testimonials', label: 'Testimonials', icon: MessageSquare },
];

const MobileNavigation = ({ activeSection, onNavigate }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { profile } = usePortfolio();

  const name = profile?.name || 'Sonjay E. Cimanes';
  const image = profile?.image || defaultAvatar;
  const github = profile?.github || 'https://github.com/sanjie01';
  const linkedin = profile?.linkedin || 'https://www.linkedin.com/in/sonjay-cimanes-2966b1372';
  const email = profile?.email || 'cimanes.sj@gmail.com';
  const resumeUrl = profile?.resumeUrl || profile?.resume_url || '/Sonjay_Cimanes_Resume.pdf';

  const navigate = (section) => {
    onNavigate(section);
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="sticky top-0 z-40 -mx-4 border-b border-[#27272A] bg-[#0A0A0B]/95 px-4 py-3 backdrop-blur sm:-mx-6 sm:px-6 lg:hidden">
        <div className="flex items-center justify-between">
          <button type="button" onClick={() => navigate('home')} className="flex min-w-0 items-center gap-3 text-left">
            <img src={image} alt="" className="h-9 w-9 rounded-full border border-[#22C55E]/50 object-cover" />
            <span className="truncate font-mono text-sm font-bold text-[#EDEDEF]">{name}</span>
          </button>
          <button
            type="button"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-[#27272A] bg-[#141416] text-[#EDEDEF] transition-colors hover:border-[#22C55E]/60 hover:text-[#4ADE80]"
          >
            {isMenuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="mt-3 border-t border-[#27272A] pt-3">
            <div className="grid grid-cols-2 gap-2">
              <a href={resumeUrl} target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2 rounded-lg border border-[#27272A] bg-[#141416] px-3 py-2.5 font-mono text-xs uppercase tracking-wider text-[#EDEDEF] hover:border-[#22C55E]/60 hover:text-[#4ADE80]">View resume</a>
              <a href={github} target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2 rounded-lg border border-[#27272A] bg-[#141416] px-3 py-2.5 font-mono text-xs uppercase tracking-wider text-[#EDEDEF] hover:border-[#22C55E]/60 hover:text-[#4ADE80]"><Github size={14} /> GitHub</a>
              <a href={linkedin} target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2 rounded-lg border border-[#27272A] bg-[#141416] px-3 py-2.5 font-mono text-xs uppercase tracking-wider text-[#EDEDEF] hover:border-[#22C55E]/60 hover:text-[#4ADE80]"><Linkedin size={14} /> LinkedIn</a>
              <a href={`mailto:${email}`} onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2 rounded-lg border border-[#27272A] bg-[#141416] px-3 py-2.5 font-mono text-xs uppercase tracking-wider text-[#EDEDEF] hover:border-[#22C55E]/60 hover:text-[#4ADE80]"><Mail size={14} /> Email</a>
            </div>
          </div>
        )}
      </header>

      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-[#27272A] bg-[#0A0A0B]/95 px-2 pb-[env(safe-area-inset-bottom)] pt-2 backdrop-blur lg:hidden" aria-label="Mobile portfolio navigation">
        <ul className="mx-auto grid max-w-lg grid-cols-4 gap-1">
          {navItems.map(({ id, label, icon: Icon }) => {
            const isActive = activeSection === id;
            return (
              <li key={id}>
                <button type="button" onClick={() => navigate(id)} className={`flex w-full flex-col items-center gap-1 rounded-lg px-1 py-2 text-[10px] font-mono uppercase tracking-wider transition-colors ${isActive ? 'text-[#4ADE80]' : 'text-[#8B8B93] hover:text-[#EDEDEF]'}`}>
                  <Icon size={17} strokeWidth={isActive ? 2.5 : 1.8} />
                  <span>{label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};

export default MobileNavigation;
